import { render } from "./VenuesView.vue?vue&type=template&id=3215c2a1"
import script from "./VenuesView.vue?vue&type=script&lang=js"
export * from "./VenuesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__